/**
 * @format
 * Google Extended Access service
 */

import axios from 'axios';

/**
 * Load the user state for Google Extended Access for a given post.
 * This state is used to determine if the user has access to the post (e.g. authenticated user who can pay for the post, or authenticated user who is a subscriber, or anonymous user who must sign-up, etc.)
 * 
 * @param {Object} data Data.  Must include postId.
 * 
 * @return Promise for resolve, reject
 */
export const loadUserState = async function (data) {
    let userState = null;
    try {
        console.log('DEBUG: Loading user state for post:', data.postId);
        const response = await axios.get('/gaa/user-state/post/' + data.postId, {
            params: {
                postId: data.postId
            }
        });

        console.log('DEBUG: Google Extended Access user state response:', response.data);

        if (response.data.success) {
            userState = {
                granted: response.data.data.granted || false,
                id: response.data.data.id || null,
            }
            if (response.data.data.grantReason) {
                userState.grantReason = response.data.data.grantReason;
            }
            // Always include registrationTimestamp, even if null
            // null = anonymous user (Google will show registration intervention)
            // undefined = logged-in user at limit (Google will show paywall, not Extended Access CTA)
            // number = logged-in user with Extended Access available (Google will show Extended Access CTA)
            if (response.data.data.registrationTimestamp !== undefined) {
                userState.registrationTimestamp = response.data.data.registrationTimestamp;
            }
            // Always include subscriptionTimestamp, even if null
            if (response.data.data.subscriptionTimestamp !== undefined) {
                userState.subscriptionTimestamp = response.data.data.subscriptionTimestamp;
            }
            
            console.log('DEBUG: loadUserState - parsed user state:', userState);
            console.log('DEBUG: loadUserState - user state details:', {
                granted: userState.granted,
                hasId: !!userState.id,
                idType: typeof userState.id,
                hasRegistrationTimestamp: !!userState.registrationTimestamp,
                registrationTimestamp: userState.registrationTimestamp,
                grantReason: userState.grantReason,
                shouldShowCTA: !userState.granted && !!userState.id && !!userState.registrationTimestamp
            });
        } else {
            userState = {
                granted: false,
            };
            console.log('DEBUG: loadUserState - API returned success: false');
        }
    } catch (error) {
        console.warn('Failed to load user state:', error);
        return {
            granted: false,
            id: null
        }
    }
    return userState;
};
